'use strict';

function isNonNullableInterval(input) {
  return input.start != null && input.end != null;
}

module.exports = isNonNullableInterval;
//# sourceMappingURL=isNonNullableInterval.cjs.map
